import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const London = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Leading salesforce Consultant and Partner in london</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content="Empower your business with Codezix – premier Salesforce consulting and implementation specialists in London. Tailored CRM solutions for outstanding results."
                />
                <meta
                    name="keywords"
                    content="Salesforce consulting london Salesforce implementation london Codezix Salesforce services CRM solutions london Salesforce experts london Salesforce partner london Custom Salesforce solutions"
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Consultant In London</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/country/london.webp')} alt="Salesforce consulting london" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <div className='explore-heading text-left'>
                                <h2>Top Salesforce Consultant in London and Trusted Partner for Business Success</h2>
                            </div>
                            <p className="prose-lg wow fadeUp">In today’s fast-moving digital landscape, having the right CRM strategy is essential for staying competitive and connected to your customers. Salesforce stands out as a powerful tool to help businesses scale, but unlocking its full potential requires expert guidance. That’s where Codezix comes in.</p>
                            <p className="prose-lg wow fadeUp">As a top Salesforce consultant in London, Codezix brings proven expertise and a strategic approach to every client engagement. We specialize in delivering tailored Salesforce solutions that streamline operations, enhance customer experiences, and drive measurable growth. Whether you're a startup looking to build your CRM from the ground up or an enterprise aiming to optimize a complex Salesforce environment, our team is here to help.</p>
                            <p className="prose-lg wow fadeUp">Our certified professionals work closely with your internal teams to understand your business needs and long-term goals. From Sales and Service Cloud implementations to Marketing Cloud automation and custom app development, we offer end-to-end Salesforce consulting designed for real impact.</p>
                            <p className="prose-lg wow fadeUp">What sets Codezix apart is our commitment to partnership. As a trusted Salesforce consultant in London, we don’t just deliver solutions—we empower your team through ongoing support, training, and continuous optimization. We’re not just consultants; we’re collaborators invested in your success.</p>
                            <p className="prose-lg wow fadeUp">Our experience spans multiple industries, including finance, healthcare, retail, and technology. This diverse background allows us to bring best practices and innovative ideas to every project, ensuring your Salesforce platform delivers maximum value.</p>
                            <p className="prose-lg wow fadeUp">If you’re looking for a Salesforce consultant in London who prioritizes results, transparency, and long-term value, Codezix is ready to help. Let’s build a smarter, more connected business—together.</p>
                        </div>
                        <div className='cloud-demo' >
                            <div className="explore-heading text-left">
                                <h2>Expert Salesforce Consulting in London – Customized CRM Solutions for Your Business</h2>
                                <p className="prose-lg">
                                    In an era where customer experience defines business success, having a flexible, scalable CRM is more important than ever. Salesforce offers powerful capabilities—but to fully leverage its potential, businesses need more than software. They need expert guidance, strategic planning, and tailored implementation. That’s exactly what Codezix delivers.
                                </p>
                                <p className="prose-lg">As a leader in Salesforce consulting in London, Codezix specializes in building custom CRM solutions that align with your specific goals and challenges. Whether you're a growing startup or a large enterprise, we help you configure and optimize Salesforce to improve customer engagement, automate processes, and increase operational efficiency.</p>
                                <p className="prose-lg">Our approach starts with understanding your business inside and out. We take time to learn how your teams work, what your customers need, and where your biggest opportunities lie. Then, our certified Salesforce professionals design and implement a system that’s both scalable and user-friendly.</p>
                                <p className="prose-lg">We offer end-to-end services—from initial setup and customization to integrations, data migration, and ongoing support. Our deep expertise spans Sales Cloud, Service Cloud, Marketing Cloud, and beyond, allowing us to tailor the perfect solution for your unique needs.</p>
                                <p className="prose-lg">What sets us apart in Salesforce consulting in London is our commitment to long-term success. We don’t just launch systems; we build partnerships. With training, post-implementation support, and continuous optimization, we ensure your team gets the most value from Salesforce at every stage.</p>
                                <p className="prose-lg"> </p>
                            </div>
                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/consulting.webp')} alt='Salesforce implementation london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Consulting</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our certified consultants thoroughly assess your business needs to streamline processes and provide strategic guidance tailored to your objectives. We tackle common CRM challenges such as low sales productivity and misalignment between departments, ensuring smoother workflows and enhanced operational efficiency.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/implementation.webp')} alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Implementation</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Transform your business with our expert implementation services. Our certified professionals excel at setting up, customizing, and configuring cloud-based solutions and add-ons, driving innovation, streamlining operations, and accelerating growth with technology that aligns with your unique business requirements.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/customization.webp')} alt='CRM solutions london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Customization</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Our consultants specialize in analyzing your business processes to deliver tailored solutions. We help address CRM challenges, boost sales productivity, and foster better interdepartmental collaboration, ensuring seamless operations and greater organizational efficiency.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/development.webp')} alt='Salesforce experts london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce App Development</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Bring your app ideas to life with our innovative, high-impact solutions. Based in London, our certified developers specialize in building custom applications and deploying them seamlessly on leading platforms, ensuring functionality, scalability, and alignment with your business goals.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/integration.webp')} alt='Salesforce partner london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Integration</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Break down silos and enhance productivity with our seamless integration services. We connect your core business systems—such as ERP, CMS, DMS, and accounting software—enabling smooth data flow, improved collaboration, and increased operational efficiency across your organization.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/migration.webp')} alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce Migration Services</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Migrate effortlessly from legacy systems with our trusted data migration services. Our experts ensure a smooth and secure transition, preserving the accuracy and integrity of your customer data, minimizing disruption, and providing you with a hassle-free migration process.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img country_img'>
                                            <img src={require('../../assets/images/country/support.webp')} alt='Salesforce consulting london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Support</h3>
                                            <p className="wow fadeUp prose-lg">
                                                We provide continuous monitoring to detect and resolve issues before they escalate. With proactive oversight, we minimize downtime, ensure smooth operations, and help prevent major disruptions, keeping your business efficient and free from unexpected interruptions.                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='client-section'>
                            <div className='explore-heading text-left'>
                                <h2>Your Trusted Salesforce Consulting Partner in London – Certified Experts at Your Service</h2>
                                <p className="prose-lg">At Codezix, we take pride in being a reliable Salesforce consulting partner in London, delivering tailored CRM solutions that help businesses grow and innovate. Our certified experts specialize in customizing Salesforce to fit your unique operational needs, ensuring smooth implementation and long-term success. As a leading Salesforce consulting partner in London, we work across industries to streamline workflows, boost productivity, and improve customer engagement. Whether you're just starting with Salesforce or enhancing an existing setup, Codezix offers the strategic support and technical expertise you need to thrive in today’s competitive landscape.</p>
                            </div>
                            <div className='row top'>
                                <Swiper
                                    breakpoints={{
                                        425: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        640: {
                                            slidesPerView: 3,
                                            spaceBetween: 10,
                                        },
                                        768: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },
                                        1024: {
                                            slidesPerView: 5,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination, Autoplay]}
                                    className="testimonialSwiper-client"
                                >
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/4.webp" alt='Salesforce implementation london' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/2.webp" alt='CRM solutions london' />
                                        </div>
                                    </SwiperSlide>

                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/3.webp" alt='Salesforce experts london' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/5.webp" alt='Salesforce partner london' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/6.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="col-md-4 col-4">
                                        <div className='client-image-slide-partnerships salesforce_certificate'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/7.webp" alt='Salesforce consulting london' />
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Expertise Across Salesforce Clouds – Delivered by Top Salesforce Consultants in London</h2>
                                <p className="wow fadeUp prose-lg text-left">
                                    Our team of expert Salesforce consultants in London delivers tailored solutions across the full suite of Salesforce Clouds. From Sales and Service Cloud to Marketing and Commerce Cloud, we help businesses streamline operations and elevate customer experiences. Our Salesforce consultants in London work closely with clients to design, implement, and optimize solutions that align with their industry needs and growth goals. Whether you're launching a new Salesforce platform or enhancing an existing one, Codezix brings the knowledge and precision needed to maximize your CRM investment.                                </p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-london#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/einstein-analytics">
                                            <h3 class="mt-0">Einstein Analytics</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-london#">
                                            <h3 class="mt-0">Salesforce Lightning</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/development-company-in-london#">
                                            <h3 class="mt-0">Health Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-center'>
                                <h2>Industries We Serve with Our Experienced Salesforce Developers in London</h2>
                                <p className="prose-lg">At Codezix, our experienced developers support industries through smart, scalable Salesforce solutions. Whether you operate in finance, healthcare, retail, or technology, our expert Salesforce developer in London will tailor each solution to your specific needs. We understand the unique challenges each industry faces and build customized workflows to improve efficiency and customer engagement. As a trusted Salesforce developer in London, we go beyond implementation to ensure long-term value and success. From automation to integration, Codezix is your partner in digital transformation—no matter your industry.</p>
                            </div>

                            <div class="row mob-imagebox">
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/healthcare.webp" alt="Salesforce implementation london" />
                                        <div class="image-text">
                                            <p>Healthcare</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/retail.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>E-Commerce</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/logistics.webp" alt="CRM solutions london" />
                                        <div class="image-text">
                                            <p>Logistics</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/financial.webp" alt="Salesforce experts london" />
                                        <div class="image-text">
                                            <p>Financial</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/manufacturing.webp" alt="Salesforce partner london" />
                                        <div class="image-text">
                                            <p>Manufacturing</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/publicsector.webp" alt="Custom Salesforce solutions" />
                                        <div class="image-text">
                                            <p>Public Sector</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/media.webp" alt="Salesforce consulting london" />
                                        <div class="image-text">
                                            <p>Media</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/it.webp" alt="Salesforce implementation london" />
                                        <div class="image-text">
                                            <p>IT Industry</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/telecom.webp" alt="Codezix Salesforce services" />
                                        <div class="image-text">
                                            <p>Telecom</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="blg">
                                        <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/industry/education.webp" alt="CRM solutions london" />
                                        <div class="image-text">
                                            <p>Education</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product">
                            <div className='explore-heading text-left'>
                                <h2>Why work with Codezix ?</h2>
                            </div>

                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Trusted Salesforce Consulting Partner</li>
                                            <li className="wow fadeUp prose-lg">80+ skilled developers with 300+ certifications</li>
                                            <li className="wow fadeUp prose-lg">89% repeat business rate, showcasing client confidence</li>
                                            <li className="wow fadeUp prose-lg">90% client retention rate, ensuring long-term success</li>
                                            <li className="wow fadeUp prose-lg">Over 10 years of industry expertise</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Comprehensive Support & Maintenance</li>
                                            <li className="wow fadeUp prose-lg">24/7 global Salesforce support across all time zones</li>
                                            <li className="wow fadeUp prose-lg">100% in-house code development for unmatched quality control</li>
                                            <li className="wow fadeUp prose-lg">99% on-time project delivery for smooth execution</li>
                                            <li className="wow fadeUp prose-lg">Thorough testing ensures reliable and high-performance Salesforce solutions</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/pd1.webp" alt='Salesforce implementation london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">3 PL Central </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in California, our client <strong>3PL Central</strong> provides a warehouse management system (WMS) that streamlines operations, boosts customer satisfaction, and accelerates business growth.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/24-Fit-Club1.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">24 Fit Club </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in the UK, <strong>24 Fit Club</strong> is a dedicated fitness community focused on health and well-being. Their expert team provides top-tier fitness guidance, online classes, and the latest insights to empower clients and promote body positivity.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/salesforce1.webp" alt='CRM solutions london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Active Campaign </h3>
                                            <p className="wow fadeUp prose-lg">
                                                Salesforce is a top-tier CRM solution, offering a powerful enterprise application accessible across multiple devices. With a dynamic app marketplace, it enhances marketing and sales alignment, generating better leads and high-quality pipelines.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/advologix.webp" alt='Salesforce experts london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Advologix</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Located in Sugarland, Texas, Advologix is a digital consultancy specializing in legal document and case management. They assist law firms, legal departments, and public service organizations in streamlining case processing through centralized information management systems.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/concert_health.webp" alt='Salesforce partner london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Concert Health</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Concert Health empowers physician practices with integrated behavioral health services, including care management, brief therapy, and psychiatric consultations. Leveraging expert clinicians, industry expertise, and advanced technology, they enhance patient care and outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/casestudy/salesforce/images/at-home-solutions.webp" alt='Custom Salesforce solutions' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">At Home Solutions</h3>
                                            <p className="wow fadeUp prose-lg">
                                                Based in London, At Home Solutions provides personalized healthcare services to improve quality of life for all ages. With over a decade of experience, they offer affordable, effective care, including companionship, tailored services, and essential support.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>Customer Success Stories</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/commerce.webp" alt='Salesforce consulting london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce Commerce Cloud: Everything You Need to Know </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today's digital age, e-commerce is essential for business success, driving fierce competition. As online shopping demand grows, businesses must adopt scalable, robust solutions to stay competitive and meet evolving consumer expectations.
                                            </p>
                                        </div>
                                        {/* <div className="services_button_right">
                                            <Link to="" ></Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/agent.webp" alt='Salesforce implementation london' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Ultimate Guide to Salesforce Agentforce</h3>
                                            <p className="wow fadeUp prose-lg">
                                                A major highlight of 2024 is Salesforce Agentforce. On Day Three of Dreamforce 2024, Salesforce introduced the third wave of AI, unveiling Agentforce—a revolutionary tool designed to boost employee productivity with advanced AI capabilities.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-3 col-sm-4'>
                                        <div className='service-section-left-img country_img'>
                                            <img src="https://d1087d7tlbvhw9.cloudfront.net/winklixi/salesforce/blog/marketing.webp" alt='Codezix Salesforce services' />
                                        </div>
                                    </div>
                                    <div className='col-lg-9 col-md-9 col-sm-8'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">
                                                What is Salesforce Mulesoft & How Codezix Supports Implementation & Customization
                                            </h3>
                                            <p className="wow fadeUp prose-lg">
                                                In today’s digital world, businesses depend on multiple applications and platforms to optimize operations and enhance customer experiences. However, seamless integration is a challenge—this is where Salesforce Mulesoft plays a crucial role...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default London;